import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Menu, X, ChevronDown, Phone, Mail } from 'lucide-react'

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [productsOpen, setProductsOpen] = useState(false)
  const location = useLocation()

  const isActive = (path) => location.pathname === path

  return (
    <nav data-component-path="client/src/components/Navbar.jsx" data-component-line="1:1" data-component-id="client/src/components/Navbar.jsx:1:1" className="bg-white shadow-md sticky top-0 z-50">
      <div data-component-path="client/src/components/Navbar.jsx" data-component-line="2:2" data-component-id="client/src/components/Navbar.jsx:2:2" className="bg-blue-900 text-white py-2">
        <div data-component-path="client/src/components/Navbar.jsx" data-component-line="3:3" data-component-id="client/src/components/Navbar.jsx:3:3" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-end items-center gap-6 text-sm">
          <a data-component-path="client/src/components/Navbar.jsx" data-component-line="4:4" data-component-id="client/src/components/Navbar.jsx:4:4" href="tel:+902627545238" className="flex items-center gap-2 hover:text-blue-200 transition-colors">
            <Phone className="w-4 h-4" />
            <span data-component-path="client/src/components/Navbar.jsx" data-component-line="5:5" data-component-id="client/src/components/Navbar.jsx:5:5">+90 262 754 52 38</span>
          </a>
          <a data-component-path="client/src/components/Navbar.jsx" data-component-line="6:6" data-component-id="client/src/components/Navbar.jsx:6:6" href="mailto:admin@eminisambalaj.info" className="flex items-center gap-2 hover:text-blue-200 transition-colors">
            <Mail className="w-4 h-4" />
            <span data-component-path="client/src/components/Navbar.jsx" data-component-line="7:7" data-component-id="client/src/components/Navbar.jsx:7:7">admin@eminisambalaj.info</span>
          </a>
        </div>
      </div>

      <div data-component-path="client/src/components/Navbar.jsx" data-component-line="8:8" data-component-id="client/src/components/Navbar.jsx:8:8" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div data-component-path="client/src/components/Navbar.jsx" data-component-line="9:9" data-component-id="client/src/components/Navbar.jsx:9:9" className="flex justify-between items-center h-20">
          <Link data-component-path="client/src/components/Navbar.jsx" data-component-line="10:10" data-component-id="client/src/components/Navbar.jsx:10:10" to="/" className="flex items-center">
            <img data-component-path="client/src/components/Navbar.jsx" data-component-line="11:11" data-component-id="client/src/components/Navbar.jsx:11:11" 
              src="https://eminis.com.tr/wp-content/uploads/2024/08/logo-eminis-yeni2024.svg" 
              alt="Eminiş Ambalaj Logo" 
              className="h-12"
              onError={(e) => {
                e.target.onerror = null
                e.target.src = 'https://via.placeholder.com/200x50/1e40af/ffffff?text=Eminis+Ambalaj'
              }}
            />
          </Link>

          <div data-component-path="client/src/components/Navbar.jsx" data-component-line="12:12" data-component-id="client/src/components/Navbar.jsx:12:12" className="hidden lg:flex items-center space-x-8">
            <Link data-component-path="client/src/components/Navbar.jsx" data-component-line="13:13" data-component-id="client/src/components/Navbar.jsx:13:13" 
              to="/" 
              className={`text-gray-700 hover:text-blue-600 font-medium transition-colors ${isActive('/') ? 'text-blue-600' : ''}`}
            >
              Ana Sayfa
            </Link>
            
            <div data-component-path="client/src/components/Navbar.jsx" data-component-line="14:14" data-component-id="client/src/components/Navbar.jsx:14:14" 
              className="relative"
              onMouseEnter={() => setProductsOpen(true)}
              onMouseLeave={() => setProductsOpen(false)}
            >
              <button data-component-path="client/src/components/Navbar.jsx" data-component-line="15:15" data-component-id="client/src/components/Navbar.jsx:15:15" className="flex items-center gap-1 text-gray-700 hover:text-blue-600 font-medium transition-colors">
                Kategoriler
                <ChevronDown className="w-4 h-4" />
              </button>
              
              {productsOpen && (
                <div data-component-path="client/src/components/Navbar.jsx" data-component-line="16:16" data-component-id="client/src/components/Navbar.jsx:16:16" className="absolute top-full left-0 mt-2 w-64 bg-white shadow-lg rounded-lg py-2 z-50">
                  <Link data-component-path="client/src/components/Navbar.jsx" data-component-line="17:17" data-component-id="client/src/components/Navbar.jsx:17:17" to="/urunler/plastik" className="block px-4 py-2 text-gray-700 hover:bg-blue-50 hover:text-blue-600">
                    Plastik Ambalaj
                  </Link>
                  <Link data-component-path="client/src/components/Navbar.jsx" data-component-line="18:18" data-component-id="client/src/components/Navbar.jsx:18:18" to="/urunler/metal" className="block px-4 py-2 text-gray-700 hover:bg-blue-50 hover:text-blue-600">
                    Metal Ambalaj
                  </Link>
                  <Link data-component-path="client/src/components/Navbar.jsx" data-component-line="19:19" data-component-id="client/src/components/Navbar.jsx:19:19" to="/hizmetler" className="block px-4 py-2 text-gray-700 hover:bg-blue-50 hover:text-blue-600">
                    Hizmetlerimiz
                  </Link>
                </div>
              )}
            </div>

            <Link data-component-path="client/src/components/Navbar.jsx" data-component-line="20:20" data-component-id="client/src/components/Navbar.jsx:20:20" 
              to="/blog" 
              className={`text-gray-700 hover:text-blue-600 font-medium transition-colors ${isActive('/blog') ? 'text-blue-600' : ''}`}
            >
              Blog
            </Link>

            <Link data-component-path="client/src/components/Navbar.jsx" data-component-line="21:21" data-component-id="client/src/components/Navbar.jsx:21:21" 
              to="/hakkimizda" 
              className={`text-gray-700 hover:text-blue-600 font-medium transition-colors ${isActive('/hakkimizda') ? 'text-blue-600' : ''}`}
            >
              Hakkımızda
            </Link>
            
            <Link data-component-path="client/src/components/Navbar.jsx" data-component-line="22:22" data-component-id="client/src/components/Navbar.jsx:22:22" 
              to="/iletisim" 
              className={`text-gray-700 hover:text-blue-600 font-medium transition-colors ${isActive('/iletisim') ? 'text-blue-600' : ''}`}
            >
              İletişim
            </Link>

            <Link data-component-path="client/src/components/Navbar.jsx" data-component-line="23:23" data-component-id="client/src/components/Navbar.jsx:23:23" 
              to="/iletisim" 
              className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors font-medium"
            >
              Teklif Al
            </Link>
          </div>

          <button data-component-path="client/src/components/Navbar.jsx" data-component-line="24:24" data-component-id="client/src/components/Navbar.jsx:24:24" 
            onClick={() => setIsOpen(!isOpen)}
            className="lg:hidden text-gray-700 hover:text-blue-600"
          >
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {isOpen && (
          <div data-component-path="client/src/components/Navbar.jsx" data-component-line="25:25" data-component-id="client/src/components/Navbar.jsx:25:25" className="lg:hidden py-4 border-t">
            <div data-component-path="client/src/components/Navbar.jsx" data-component-line="26:26" data-component-id="client/src/components/Navbar.jsx:26:26" className="flex flex-col space-y-4">
              <Link data-component-path="client/src/components/Navbar.jsx" data-component-line="27:27" data-component-id="client/src/components/Navbar.jsx:27:27" to="/" className="text-gray-700 hover:text-blue-600 font-medium" onClick={() => setIsOpen(false)}>
                Ana Sayfa
              </Link>
              <Link data-component-path="client/src/components/Navbar.jsx" data-component-line="28:28" data-component-id="client/src/components/Navbar.jsx:28:28" to="/urunler/plastik" className="text-gray-700 hover:text-blue-600 font-medium" onClick={() => setIsOpen(false)}>
                Plastik Ambalaj
              </Link>
              <Link data-component-path="client/src/components/Navbar.jsx" data-component-line="29:29" data-component-id="client/src/components/Navbar.jsx:29:29" to="/urunler/metal" className="text-gray-700 hover:text-blue-600 font-medium" onClick={() => setIsOpen(false)}>
                Metal Ambalaj
              </Link>
              <Link data-component-path="client/src/components/Navbar.jsx" data-component-line="30:30" data-component-id="client/src/components/Navbar.jsx:30:30" to="/hizmetler" className="text-gray-700 hover:text-blue-600 font-medium" onClick={() => setIsOpen(false)}>
                Hizmetlerimiz
              </Link>
              <Link data-component-path="client/src/components/Navbar.jsx" data-component-line="31:31" data-component-id="client/src/components/Navbar.jsx:31:31" to="/blog" className="text-gray-700 hover:text-blue-600 font-medium" onClick={() => setIsOpen(false)}>
                Blog
              </Link>
              <Link data-component-path="client/src/components/Navbar.jsx" data-component-line="32:32" data-component-id="client/src/components/Navbar.jsx:32:32" to="/hakkimizda" className="text-gray-700 hover:text-blue-600 font-medium" onClick={() => setIsOpen(false)}>
                Hakkımızda
              </Link>
              <Link data-component-path="client/src/components/Navbar.jsx" data-component-line="33:33" data-component-id="client/src/components/Navbar.jsx:33:33" to="/iletisim" className="text-gray-700 hover:text-blue-600 font-medium" onClick={() => setIsOpen(false)}>
                İletişim
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  )
}

export default Navbar